import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IChatbotPublic } from "../../../Components/ChatbotPublic/IChatbotPublic";

export const WritingChatbotPublicSlicer = createSlice({
  name: "WritingChatbotPublicSlicer",
  initialState: {} as IReduxState<IChatbotPublic>,
  reducers: {
    WritingchatbotPublic: (state, _: PayloadAction<IChatbotPublic>) => {
      state.isLoading = true;
    },
    successWritingChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureWritingChatbotPublic: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearWritingChatbotPublicStatus: (state) => {
      state.data = {};
    },
  },
});

export const {
  WritingchatbotPublic,
  successWritingChatbotPublic,
  failureWritingChatbotPublic,
  clearWritingChatbotPublicStatus,
} = WritingChatbotPublicSlicer.actions;

export default WritingChatbotPublicSlicer.reducer;
